export enum OnboardingDialogStep {
  FINISH_INVITED = 'FINISH_INVITED',
  FINISH_INVITES_SKIPPED = 'FINISH_INVITES_SKIPPED',
}

export interface OnboardingDialogData {
  step: OnboardingDialogStep;
}

export interface OnboardingDialogResult {
  action: OnboardingDialogAction | undefined;
}

export type OnboardingDialogAction = 'primary' | 'secondary';

interface FooterActionLink {
  type: 'link';
  text: string;
  link: string;
}

interface FooterActionText {
  type: 'text';
  text: string;
}

export type FooterAction = FooterActionText | FooterActionLink;
